/**
 * 改图模式
 * state状态
 * @typedef {Object} AppState
 * @description 应用本身使用的redux state
 * @property {Object}
 */

import { REDRAW_MODE, TOOLBAR, DEFAULT_PENCIL_SIZE, BRUSH_TOOL } from '@/views/AIEditV3/consts'

const App = {
    state: {
      inited: false, //画布初始化完成
      reDrawMode: 20,
      useCanvas: null, // 正在使用的画布实例
      scale: 0.3, // 画布缩放比
      isDragging: false, // 是否正在拖拽画布
      isDraggingCard: false, // 是否正在拖拽卡片
      isCanvasWheelAndScaling: false, // 是否正在缩放和滚动画布
      isEditing: false, // 进入改图模式
      // 画笔
      operation: TOOLBAR.MANU_PAINT, //
      brushTool: BRUSH_TOOL.PENCIL, // 画笔类型
      pencilRate: DEFAULT_PENCIL_SIZE,
      selectCanvasOperation: { // 选中画布的操作实例
        brushStack: null,
        canvas: null
      },
      // 换物体
      copyReplaceData:{
        smearCoord: [], // 涂抹轨迹
        replace_img: null,
        positive_desc: ''
      },
      //图片相关
      selectedImage:null, //当前选中的图片url
      selectedCardId: null, // 当前选中的cardId
      selectedCardData:null, //当前选中的卡片
      selectedCardDataCopy:null, //发起任务时当前选中的卡片的备份
      leftBaseLine:'', //当前项目的新图左侧基线
      zoomRatio: 4, // 放大倍率
      imageOriginalSize:[0, 0],  //图片原始尺寸 [width, height](不是原图尺寸)
      picNum: 1, //出图张数
      scene: 1, //重绘类型 1-上传图片改图 2-在作品上改图
      //算力相关
      userTemporaryTops:'',  //当前用户剩余算力
      isRechargeXZB:false,    //上报用字段
      rechargeSuccessVersion: 0, //充值/兑换成功版本号，递增后用于通知页面重新拉取算力报价（如会员充值赠送免费次数后需重算）
      //操作相关
      reDrawLoading:false,  //判断是否正在改图中
      resType:'',  //灵感图跳转过来时用到的改图参数
      sof:'',  
      isOpenProject:false, //是否打开作图记录
      isFromProjectList:false, //是否来自左侧项目的查看全部项目
      isOpenFavorites:false, //是否打开收藏夹
      isOpenOperation:true,//是否打开操作栏
      isOpenCommonBox:false, //是否打开公共组件,总开关
      isDragFromRecord:false, //是否从记录拖入，控制面板的框选冲突
      choosedId:null,
      //项目相关
      currentProjectName:'未命名项目', //当前选择的项目名称
      currentProjectId:null, //当前选择的项目id
      copyCardData: null, //复制的卡片数据
      // 换物体
      replaceImage: '',
      replaceImage2: '',
      descriptionWord: '',
      // 细节增强
      detailZoomRatio: 4, // 放大倍率
      modeWordList: [], // 选中风格对应的描述词

      detailMode: null,
      //exampleModal上上传的图片
      exampleImageUrl: null,
      // 查看大图再优化跳转数据
      bigImgReDrawData: null, // { data: null, type: '',  // string:  画同款: copy, 用作参考图: useReference , 使用图片： useImg }
      isSaved: true,
      // 加载工具集项目
      toolProjectData: null,
      isShowOverlay: false,
      // 开始从收藏夹和历史记录拖拽上传文件
      isDragUploading: false,
      selectImgsListObj: null, // 画布上批量框选的图片数据：用户上传图片链接和ai生成图片id
      // 闪烁提示
      isShowFlash: false,
    },
    reducers: {
      /**
       * @description 更新state
       * @param state: 当前state
       * @param payload: 更新state对象
       */
      updateState(state, payload) {
        return {
          ...state,
          ...payload
        };
      },
    },
    effects: () => ({
      setInited(status) {
        this.updateState({ inited: status });
      },
      setReDrawMode(mode) {
        this.updateState({ reDrawMode: mode });
      },
      setSelectedCardId(mode) {
        this.updateState({ selectedCardId: mode });
      },
      setUseCanvas(canvas) {
        this.updateState({ useCanvas: canvas });
      },
      setScale(scaleNum) {
        this.updateState({ scale: scaleNum });
      },
      setIsDragging(status) {
        this.updateState({ isDragging: status });
      },
      setIsDraggingCard(status) {
        this.updateState({ isDraggingCard: status });
      },
      setIsCanvasWheelAndScaling(status) {
        this.updateState({ isCanvasWheelAndScaling: status });
      },
      setOperation(status) {
        this.updateState({ operation: status });
      },
      setBrushTool(status) {
        this.updateState({ brushTool: status });
      },
      setPencilRate(rate) {
        this.updateState({ pencilRate: rate });
      },
      setSelectCanvasOperation(instanceObj) {
        this.updateState({ selectCanvasOperation: instanceObj });
      },
      setSmearCoord(coords) {
        this.updateState({ smearCoord: coords });
      },
      setCurrentProjectId(id) {
        this.updateState({ currentProjectId: id });
      },
      setCurrentProjectName(name) {
        this.updateState({ currentProjectName: name });
      },
      setSelectedImage(mode) {
        this.updateState({ selectedImage: mode });
      },
      setZoomRatio(param) {
        this.updateState({ zoomRatio: param });
      },
      setImageOriginalSize(param) {
        this.updateState({ imageOriginalSize: param });
      },
      setPicNum(param) {
        this.updateState({ picNum: param });
      },
      setUserTemporaryTops(param) {
        this.updateState({ userTemporaryTops: param });
      },
      setIsRechargeXZB(param) {
        this.updateState({ isRechargeXZB: param });
      },
      setRechargeSuccessVersion(param) {
        this.updateState({ rechargeSuccessVersion: param });
      },
      setScene(param) {
        this.updateState({ scene: param });
      },
      setReDrawLoading(param) {
        this.updateState({ reDrawLoading: param });
      },
      setResType(param) {
        this.updateState({ resType: param });
      },
      setSof(param) {
        this.updateState({ sof: param });
      },
      setSelectedCardData(param) {
        this.updateState({ selectedCardData: param });
      },
      setSelectedCardDataCopy(param) {
        this.updateState({ selectedCardDataCopy: param });
      },
      setLeftBaseLine(param) {
        this.updateState({ leftBaseLine: param });
      },
      setIsOpenProject(param) {
        this.updateState({ isOpenProject: param });
      },
      setIsFromProjectList(param) {
        this.updateState({ isFromProjectList: param });
      },
      setIsOpenFavorites(param) {
        this.updateState({ isOpenFavorites: param });
      },
      setIsOpenOperation(param) {
        this.updateState({ isOpenOperation: param });
      },
      setCopyCardData(param) {
        this.updateState({ copyCardData: param });
      },
      setIsOpenCommonBox(param) {
        this.updateState({ isOpenCommonBox: param });
      },
      setCopyReplaceData(param) {
        this.updateState({ copyReplaceData: param });
      },
      setIsDragFromRecord(param) {
        this.updateState({ isDragFromRecord: param });
      },
      setReplaceImage(param){
        this.updateState({ replaceImage: param });
      },
      setReplaceImage2(param){
        this.updateState({ replaceImage2: param });
      },
      setDescriptionWord(param){
        this.updateState({ descriptionWord: param });
      },
      setDetailMode(param) {
        this.updateState({ detailMode: param });
      },
      setDetailZoomRatio(param) {
        this.updateState({ detailZoomRatio: param });
      },
      setExampleImageUrl(param) {
        this.updateState({ exampleImageUrl: param });
      },
      setChoosedId(param) {
        this.updateState({ choosedId: param });
      },
      setIsEditing(param) {
        this.updateState({ isEditing: param });
      },
      setBigImgReDrawData(param) {
        this.updateState({ bigImgReDrawData: param });
      },
      setIsSaved(param) {
        this.updateState({ isSaved: param });
      },
      setToolProjectData(param) {
        this.updateState({ toolProjectData: param });
      },
      setIsShowOverlay(param){
        this.updateState({ isShowOverlay: param });
      },
      setIsDragUploading(status) {
        this.updateState({ isDragUploading: status});
      },
      setSelectImgsListObj(param) {
        this.updateState({ selectImgsListObj: param});
      },
      setIsShowFlash(param) {
        this.updateState({ isShowFlash: param});
      }
    })
  };
  
export default App;
  